import { FC, ComponentProps } from 'react';
import { Button } from '@altermaind/web/ui';

type Props = ComponentProps<typeof Button>;

export const Cta: FC<Props> = ({ children, ...props }) => {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Button type='button' mt='s' variant='link/primary' {...props}>
      {children}
    </Button>
  );
};
